import { render, staticRenderFns } from "./LottieWeb.vue?vue&type=template&id=24fb7f2d&"
import script from "./LottieWeb.vue?vue&type=script&lang=js&"
export * from "./LottieWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports